import { Button } from "~/components/Button";

type Props = {
	group: string;
};

export const RecoverGroupButton: React.FC<Props> = () => {
	return <Button>Restaurar exercícios padrão</Button>;
};
